/* strip-ansi/index */ function _(require, module, exports) {
    var ansiRegex = require(42) /* ansi-regex */();
    module.exports = function (str) {
        return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
    };
}
